







import Vue from 'vue';

export default Vue.extend({
  name: 'UserInput',
  props: {
    message: String
  },
  data() {
    return {
      submitted: false,
      input: '',
    }
  },
  methods: {
    focusInput() {
      (this.$refs as any).userInput.focus();
    },
    submit() {
      if (this.submitted) return;
      this.submitted = true;
      this.$emit('submit', this.input);
    }
  },
  mounted() {
    // TODO: 全画面タップでフォーカス
    this.focusInput();
  }
});
